export const HAIRLINE = '1px solid rgba(153, 153, 153, 0.3)'
